export const CURRENCY_FORMATTER = (value) => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

export const CURRENCY_PARSER = (value) => value.replace(/\$\s?|(,*)/g, '')
